import { Navigate, useLocation, useParams } from 'react-router-dom'
import { useUser } from 'app/utils'

export default function Index() {
  const { userId } = useParams()
  const location = useLocation()
  const user = useUser()
  const isNewUser = userId === `new`

  if (!user) return null

  if (!user.workspaceId) return <Navigate to={`${location.pathname}/details`} replace />

  return <Navigate to={isNewUser ? `${location.pathname}/invite` : `${location.pathname}/workspace`} replace />
}
